import { LISTATTACHMENTS} from '../constants';
const INITIAL_STATE = {};
export default (state = INITIAL_STATE,action)=>{
  switch(action.type){
    case LISTATTACHMENTS:
      return action.payload;
    default:
      return state;
  }
}
